import { each, eachL, filterL, go, takeAll } from "fxjs/es";
import { getAllCpdPaths, getAllPaths, unitePath } from "./path_fns.js";
import { optimizePath } from "./path_optimizer.js";
import { handlingSimplify } from "./simplify_path.js";

export const outlineProcessing = ({
  paper_scope,
  is_set_style = false,
  is_process_simplify = false,
}) => {
  // let time;
  const process_ll_area = 100;
  const opacity_limit = 0.1;
  const control_percent = 1.5;
  const control_size = Math.round(
    ((paper_scope.view.size.width + paper_scope.view.size.height / 2) *
      control_percent) /
      100
  );

  //=====================================================//
  //  1차 compound path 정리
  //    - viewBox outline 요소 제거
  //    - single path로 unite replace
  //=====================================================//
  // time = getTime();
  go(
    getAllCpdPaths(paper_scope.project.activeLayer),
    filterL((cpd_path) => {
      if (cpd_path.opacity < opacity_limit) {
        cpd_path.remove();
      } else {
        return cpd_path;
      }
    }),
    eachL((cpd_path) => {
      let united_path;
      go(
        getAllPaths(cpd_path),
        each((path) => {
          united_path = unitePath(path, united_path);
        })
      );
      cpd_path.replaceWith(united_path);
    }),
    takeAll
  );

  //=====================================================//
  //  2차 path 정리
  //    - viewBox outline 제거
  //    - zero segment path 제거
  //    - crazy small area path 제거
  //    - clip mask 제거
  //    - 시계방향으로 모든 path 변경
  //    - 모든 path closed
  //    ====> 남아있는 모든 path unite (path가 하나로 merge되는 시점)
  //=====================================================//
  let outline_paths;

  go(
    getAllPaths(paper_scope.project.activeLayer),
    each((path) => {
      if (
        path.opacity < opacity_limit ||
        path.clipMask === true ||
        path.segments.length === 3 ||
        Math.abs(path.area) < process_ll_area
      ) {
        path.remove();
      } else {
        path.clockwise = true;
        path.closePath();
        outline_paths = unitePath(path, outline_paths);
        path.remove();
      }
    })
  );

  //=====================================================//
  //  3차 path 정리
  //    - remove unnecessary curves
  //    - path simplify (Ramer–Douglas–Peucker algorithm)
  //=====================================================//
  /* Simplify */
  if (is_process_simplify) {
    if (outline_paths instanceof paper_scope.CompoundPath) {
      go(
        getAllPaths(outline_paths),
        each((path) => {
          const simplified_path = handlingSimplify({ path, paper_scope });
          simplified_path && path.replaceWith(simplified_path);
        })
      );
    } else {
      const simplified_path = handlingSimplify({
        path: outline_paths,
        paper_scope,
      });
      simplified_path && (outline_paths = simplified_path);
    }
  }

  optimizePath(outline_paths, control_size, false);
  // consoleTime("Outline Processing", time, getTime());

  // const seg_tot_before = getNumberOfSegments(outline_paths);
  // time = getTime();

  if (is_set_style) {
    outline_paths.set({
      fillColor: "transparent",
      strokeColor: "black",
      strokeWidth: 1,
      selected: true,
    });
    paper_scope.project.activeLayer.addChild(outline_paths);
  }
  return outline_paths;
};
